<template>
  <div class="center-top">
    <div class="legend">
      <div class="item">
        <div class="icon"></div>
        综合型
      </div>
      <div class="item">
        <div class="icon blue"></div>
        一般型
      </div>
      <div class="item">
        <div class="icon yellow"></div>
        简易型
      </div>
      <div class="item">
        <div class="icon closed">
          <img src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756287-62648abf707ba.png" />
        </div>
        暂停营业
      </div>
    </div>
    <div class="search">
      <div class="top">
        运营中的驿站：
        <div class="fx-led count">
          18 <span class="num"> <span style="font-size: 20px;">/</span> 20 <span>家</span></span>
        </div>
      </div>
      <div class="select">
        <a-select style="width: 100%" placeholder="按区查看" v-model="area" @change="areaChange" :options="options"></a-select>
      </div>
      <div class="list">
        <div class="item" v-for="(item, i) in stadium_list" :key="item.id" @click="show_item(item)">
          <div class="info">{{i + 1}}、{{item.name}}</div>
          <img v-if="item.status != 1" src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756006-626489a6d703e.png" class="icon" />
          <img v-else-if="item.type == '综合型'" src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756000-626489a08abc2.png" class="icon" />
          <img v-else-if="item.type == '简易型'" src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756004-626489a44ccb9.png" class="icon" />
          <img v-else-if="item.type == '一般型'" src="https://oss.mcloud.moveclub.cn/mcloudbkh5/20220414/1649898062-6257724eb7db7.png" class="icon" />
        </div>
      </div>
    </div>
    <div id="container">
      Map
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import api from '@/api'

export default {
  data() {
    return {
      map: null,
      loca: null,
      area: '',
      stadium_list: [],
      options: [
        { value: '', label: '全部' },
        { value: 310101, label: '黄浦区' },
        // { value: 310103, label: '卢湾区' },
        { value: 310104, label: '徐汇区' },
        { value: 310105, label: '长宁区' },
        { value: 310106, label: '静安区' },
        { value: 310107, label: '普陀区' },
        // { value: 310108, label: '闸北区' },
        { value: 310109, label: '虹口区' },
        { value: 310110, label: '杨浦区' },
        { value: 310112, label: '闵行区' },
        { value: 310113, label: '宝山区' },
        { value: 310114, label: '嘉定区' },
        { value: 310115, label: '浦东新区' },
        { value: 310116, label: '金山区' },
        { value: 310117, label: '松江区' },
        { value: 310118, label: '青浦区' },
        // { value: 310119, label: '南汇区' },
        { value: 310120, label: '奉贤区' },
        { value: 310230, label: '崇明县' },
      ],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    show_item(item) {
      this.map.setZoomAndCenter(14.5, [item.longitude, item.latitude]);
    },
    areaChange() {
      this.get_data(this.map).then((data) => {
        this.map.clearMap()

        this.map.add(data)

        this.map.setFitView()
      })
    },
    init() {
      AMapLoader.load({
        key: '51d7b88237507c89371c1d3424afa4ca', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: '2.0.0', // Loca 版本，缺省 1.3.2
        },
      })
        .then((AMap) => {
          const map = new AMap.Map('container', {
            zoom: 10.5,
            center: [121.44573, 31.218372],
            mapStyle: 'amap://styles/45311ae996a8bea0da10ad5151f72979',
            // showLabel: false,
            viewMode: '3D',
          })
          map.setMapStyle('amap://styles/darkblue')

          this.get_data(map).then((data) => {
            map.add(data)

            map.setFitView()

            this.map = map
          })
        })
        .catch((e) => {
          console.error(e)
        })
    },
    get_data(map) {
      return api.common.stadiumList({ gid: 'eStBcUhqZ0ZvRE09', district_id: this.area }).then((r) => {
        const markerList = []
        r.data.stadium_list.forEach((row) => {
          if (row.longitude * 1 && row.latitude * 1) {
            if (row.status == 1) {
              if (row.type == '综合型') {
                row.img = 'https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756000-626489a08abc2.png'
              } else if (row.type == '简易型') {
                row.img = 'https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756004-626489a44ccb9.png'
              } else {
                row.img = 'https://oss.mcloud.moveclub.cn/mcloudbkh5/20220414/1649898062-6257724eb7db7.png'
              }
            } else {
              row.img = 'https://oss.mcloud.moveclub.cn/mcloudbkh5/20220424/1650756006-626489a6d703e.png'
            }
            const marker = new AMap.Marker({
              position: new AMap.LngLat(row.longitude * 1, row.latitude * 1), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: row.name,
              offset: new AMap.Pixel(-13, -28),
              icon: new AMap.Icon({
                image: row.img,
                size: [25, 28],
                imageSize: new AMap.Size(25, 28),
              }),
            })

            marker.on('click', () => {
              //构建信息窗体中显示的内容
              var info = []
              info.push(`<div id="map-info-dialog"><div class="title">${row.name}</div>`)
              info.push(`<div class="item"><div class="label">${row.address}</div></div>`)
              info.push(`<div class="item"><div class="label">当日打卡：</div><div class="val">${row.num}次</div></div>`)
              info.push(`<div class="btn-area"><a href="/?stid=${row.id}" class="btn">查看详情</a></div></div>`)

              const infoWindow = new AMap.InfoWindow({
                isCustom: true,
                closeWhenClickMap: true,
                offset: new AMap.Pixel(0, -28),
                content: info.join(''), //使用默认信息窗体框样式，显示信息内容
              })

              infoWindow.open(map, [row.longitude * 1, row.latitude * 1])
            })

            markerList.push(marker)
          }
        })

        this.stadium_list = r.data.stadium_list

        return markerList
      })
    },
  },
}
</script>

<style lang="less">
#map-info-dialog {
  background: url(../../../assets/yundong/dialog-bg.png) no-repeat center center / cover;
  width: 184px;
  height: 136px;
  padding: 12px 10px;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #fff;
    margin-top: 4px;
    .label {
      color: rgba(255, 255, 255, 0.8);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .btn-area {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    width: 76px;
    height: 24px;
    background: #005ed2;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-top: 10px;
  }
}
</style>

<style>
.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
  background: #fff;
}

.content-window-card p {
  height: 2rem;
}
</style>

<style lang="less" scoped>
.center-top {
  padding: 10px;
  position: relative;
  .legend {
    position: absolute;
    right: 16px;
    top: 18px;
    background: #00194a;
    border: 1px solid rgba(49, 138, 248, 1);
    padding: 5px 10px;
    display: flex;
    align-items: center;
    z-index: 10000;
    .item {
      display: flex;
      align-items: center;
      color: #fff;
      .icon {
        width: 14px;
        height: 14px;
        background: #ff6c40;
        border-radius: 2px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.closed {
          background: none;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &.blue {
          background: #03bce2;
        }
        &.yellow {
          background: #f7b500;
        }
      }
      & + .item {
        margin-left: 16px;
      }
    }
  }
  .search {
    position: absolute;
    left: 16px;
    top: 18px;
    width: 295px;
    height: 229px;
    background: #09115b;
    border: 1px solid #4684d0;
    color: #fff;
    z-index: 1000;
    padding: 15px;
    .top {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .count {
        font-size: 30px;
        .num {
          font-size: 22px;
          span {
            opacity: 0.65;
            font-size: 14px;
          }
        }
      }
    }
    .list {
      margin-top: 12px;
      height: 114px;
      overflow: auto;
      padding-bottom: 32px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 238px;
        height: 32px;
        background: #002874;
        border-radius: 4px;
        padding: 6px 10px;
        & + .item {
          margin-top: 9px;
        }
        .info {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .icon {
          width: 18px;
          height: 20px;
        }
      }
    }
  }
  #container {
    width: 809px;
    height: 447px;
  }
}
</style>
